export default "__VITE_ASSET__B$nd90bH__"